import Vue from "vue";
import axios from "axios";
import App from "./App.vue";

//plugins
import DashboardPlugin from "./plugins/dashboard-plugin";
import VueAxios from "vue-axios";
import VueMeta from 'vue-meta';
import IsDemo from "./plugins/isDemo"

import "./assets/css/style.css";

// router&store setup
import router from "./router";
import store from "./store";
import DatePicker from 'vue2-datepicker';

DatePicker.locale('es', {
  formatLocale: {
    firstDay: 0, 
    months: ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'],
    monthsShort: ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'],
    weekdays: ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'],
    weekdaysShort: ['dom','lun','mar','mié','jue','vie','sáb'],
    weekdaysMin: ['Do','Lu','Ma','Mi','Ju','Vi','Sá'],
  },
  yearFormat: 'YYYY',
  monthFormat: 'MMMM',
  monthBeforeYear: false,
});
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);
Vue.use(IsDemo);
Vue.use(VueMeta, { keyName: 'head' });
//Vue.use(require('vue-moment'));
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
moment.locale('es');

Vue.use(VueMoment, {
    moment,
});

Vue.filter('horaFija', function (value, format) {
  return value ? moment.parseZone(value).format(format) : '';
});

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

//const token = localStorage.getItem("vue-authenticate.vueauth_access_token")

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.VUE_APP_WEBSOCKETS_KEY,
    wssPort: process.env.VUE_APP_WEBSOCKETS_PORT,
    wsHost: process.env.VUE_APP_WEBSOCKETS_SERVER,
    wsPort: process.env.VUE_APP_WEBSOCKETS_PORT,
    //wssHost: process.env.VUE_APP_WEBSOCKETS_SERVER,
    forceTLS: process.env.VUE_APP_WEBSOCKETS_FORCETLS,
    encrypted: process.env.VUE_APP_WEBSOCKETS_ENCRYPTED,
    disableStats: true,
    cluster: 'us2',
    enabledTransports: ["ws", "wss"],
});

Pusher.logToConsole = true;


/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   render: h => h(App),
//   router
// });
/* eslint-disable no-new */
const app = new Vue({
  router: router,
  store: store,
  el: "#app",
  render: h => h(App)
});

store.$app = app;
